import DateFormatter from "../../../utils/DateFormatter";
import ProvidedField from "./ProvidedField";

export default class InboundTransactionExtended {
    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.remittanceBrandOrderNo = jsonResponse["remittance-brand-order-no"];
        this.collectionPin = jsonResponse["collection-pin"];
        this.beneficiaryFirstName = jsonResponse["beneficiary-first-name"];
        this.beneficiaryLastName = jsonResponse["beneficiary-last-name"];
        this.beneficiaryMsisdn = jsonResponse["beneficiary-msisdn"];
        this.customerFirstName = jsonResponse["customer-first-name"];
        this.customerLastName = jsonResponse["customer-last-name"];
        this.date = jsonResponse["date-created"];
        this.inboundTransactionType = jsonResponse["inbound-transaction-type"];
        this.inboundTransactionTypeDisplayValue = jsonResponse["inbound-transaction-type-display-value"];
        this.inboundTransactionStatus = jsonResponse["inbound-transaction-status"];
        this.inboundTransactionStatusDisplayValue = jsonResponse["inbound-transaction-status-display-value"];
        this.countryFrom = jsonResponse["country-from"];
        this.countryFromDisplayValue = jsonResponse["country-from-display-value"];
        this.beneficiaryCurrency = jsonResponse["beneficiary-currency"];
        this.beneficiaryAmount = jsonResponse["beneficiary-amount"];
        this.remittancePartner = jsonResponse["remittance-partner"];
        this.integratingPartner = jsonResponse["integrating-partner"];
        this.senderType = jsonResponse["sender-type"]

        this.providedFields = [];
        if (jsonResponse["provided-fields"]) {
            jsonResponse["provided-fields"].forEach(field => {
                this.providedFields.push(new ProvidedField(field));
            })
        }

        this.fullName = this.customerFirstName + " " + this.customerLastName;

        this.displayDate = DateFormatter.FormatTransactionCardDate(this.date);
    }
}
